import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import InfoIcon from 'components/icons/InfoIcon';
import MapPinIcon from 'components/icons/MapPinIcon';
import WarningIcon from 'components/icons/WarningIcon';

import { TEST_ID } from './constants';
import type { BannerIcon, BannerVariant, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const variantClassMap: Record<BannerVariant, string> = {
    context: styles.context,
    info: styles.info,
    warn: styles.warn
};

const BANNER_ICON_COMPONENT: Record<BannerIcon, FunctionComponent> = {
    info: InfoIcon,
    mapPin: MapPinIcon,
    none: () => null,
    warning: WarningIcon
};

const DEFAULT_ICON_BY_VARIANT: Record<BannerVariant, BannerIcon> = {
    context: 'mapPin',
    info: 'info',
    warn: 'warning'
};

const Banner: FunctionComponent<Props> = ({
    className = '',
    icon,
    metadata,
    testId = TEST_ID,
    text,
    variant
}) => {
    const variantClass = variantClassMap[variant];
    const resolvedIcon = icon ?? DEFAULT_ICON_BY_VARIANT[variant];
    const IconComponent = BANNER_ICON_COMPONENT[resolvedIcon];

    return (
        <HorizontalContainer
            className={`${styles.banner} ${variantClass} ${className}`}
            testId={testId}>
            <IconComponent />

            <Wrapper className={styles.text}>{text}</Wrapper>

            {metadata && <Wrapper className={styles.metadata}>{metadata}</Wrapper>}
        </HorizontalContainer>
    );
};

export default Banner;
